<template>
    <v-container class="app-page-container"> 
        <v-card class="shadow-none app-page-card" v-if="content">
            <v-card-title>
                Competition: {{content.competition.name}} <br />
            </v-card-title>
            <table class="show-competition-quick-info-table">
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">Score:</td><td class="show-competition-quick-info-table__data">{{content.score}} + {{content.teacher_score}} =  {{content.score + content.teacher_score}}</td>
                </tr>
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">Spent time:</td><td class="show-competition-quick-info-table__data">{{content.spent_time}} s ({{Math.floor(content.spent_time/3600)}} h {{Math.floor((content.spent_time % 3600)/60)}} min {{Math.floor(content.spent_time % 3600 % 60)}} s)</td>
                </tr>
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">Begin at:</td><td class="show-competition-quick-info-table__data">{{content.begin_at}}</td>
                </tr>
                <tr>
                    <td class="show-competition-quick-info-table__side-heading">End at:</td><td class="show-competition-quick-info-table__data">{{content.end_at}}</td>
                </tr>
            </table>
            {{content.description}} <br>

            <div class="show-competition-main-table">
                <div class="show-competition-main-table__heading">
                    <div class="show-competition-main-table-heading__item"></div>
                    <div class="show-competition-main-table-heading__item"></div>
                    <div class="show-competition-main-table-heading__item">auto-score</div>
                    <div class="show-competition-main-table-heading__item">teacher-score</div>
                    <div class="show-competition-main-table-heading__item">sum</div>
                    <div class="show-competition-main-table-heading__item">attempts</div>
                    <div class="show-competition-main-table-heading__item">comment</div>
                    <div class="show-competition-main-table-heading__item"></div>
                </div>

                <div class="show-competition-main-table__data-group cursor-pointer" v-for="(task, index) in content.task_list" :key="index">
                    <div class="show-competition-main-table__row">
                            <div @click="showAtts(index)" class="show-competition-main-table-row__item">{{index+1}}.</div>
                            <div @click="showAtts(index)" class="show-competition-main-table-row__item"><v-icon> {{getTaskIcon(task.task_type_id)}}</v-icon></div>
                            <div @click="showAtts(index)" class="show-competition-main-table-row__item">{{task.score}}</div>
                            <div class="show-competition-main-table-row__item" v-if="content.allow_edit">
                                <v-layout row wrap>
                                    <v-flex xs4>
                                        <v-text-field v-model="task.teacher_score"></v-text-field>   
                                    </v-flex>
                                    <v-flex xs6><v-icon style="margin-top:20px" title="Save all" @click=saveData()>save</v-icon></v-flex>
                                </v-layout>
                            </div>
                            <div @click="showAtts(index)" v-if="!content.allow_edit" class="show-competition-main-table-row__item">
                                {{task.teacher_score}}
                            </div>
                            <div @click="showAtts(index)" class="show-competition-main-table-row__item">{{parseInt(task.score) + parseInt(task.teacher_score)}} / {{task.max_score}}</div>
                            <div @click="showAtts(index)" class="show-competition-main-table-row__item"><v-icon>play_for_work</v-icon> {{task.attempts}}</div>

                            <div class="show-competition-main-table-row__item">
                                <v-textarea v-if="content.allow_edit" 
                                  rows="2"
                                  outlined
                                  v-model="task.comment">
                                </v-textarea>
                                
                                <div @click="showAtts(index)" v-if="task.comment && !content.allow_edit" v-html="processComment(task.comment)">
                                </div>
                            </div>
                            <div v-if="content.allow_edit" style="margin-top:20px">
                                <v-icon title="Save all" @click=saveData()>save</v-icon>
                            </div>
                            
                            <div @click="showAtts(index)" class="show-competition-main-table-row__item justify-content-center">
                                <v-icon v-if="showAttempts != index">expand_more</v-icon>
                                <v-icon v-if="showAttempts == index">expand_less</v-icon>
                            </div>
                    </div>
                    <div :class="[showAttempts == index ? 'show-attempts-content--active' : 'show-attempts-content']" v-if="showAttempts == index">
                            <v-icon @click="showAttempts = -1" class="float-right show-attempts-content__close-icon">close</v-icon>

                            <div class="show-attempts-content__side-menu" v-if="task.task_type_id >= 8">
                                <h4 class="show-attempts-content__title">Attempts:</h4>
                                <div v-for="(attempt, index2) in task.attempt_list" :key="index2" @click="showCode = index2" :class="[showCode == index2 ? 'show-attempts-content__side-code-area show-attempts-content__side-code-area--active' : 'show-attempts-content__side-code-area']">
                                    <span class="competition-result__code-link">
                                        {{index2+1}}. {{attempt.time_stamp}} (score: <b>{{attempt.score}}</b>)
                                    </span>
                                    <div v-if="showCode == index2" class="competition-result__code-editor">
                                        <CodesInEditor v-bind:answer="attempt.answer" />
                                    </div>
                                </div>
                            </div>


                            <div class="show-attempts-content__side-menu" v-if="task.task_type_id < 8">
                                <h4 class="show-attempts-content__title">Attempts:</h4>
                                <div v-for="(attempt, index2) in task.attempt_list" :key="index2" @click="showCode = index2" :class="[showCode == index2 ? 'show-attempts-content__side-code-area show-attempts-content__side-code-area--active' : 'show-attempts-content__side-code-area']">
                                    <span class="competition-result__code-link">
                                        {{index2+1}}. {{attempt.time_stamp}} (score: <b>{{attempt.score}}</b>)
                                    </span>
                                    <div v-if="showCode == index2" class="competition-result__text-answer">
                                        <ul class="answer-list">
                                            <li v-for="(answer, index3) in JSON.parse(attempt.answer)" :key="index3">{{answer}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import CodesInEditor from '../../elements/programming/codes_in_editor.vue'
import axios from '../../axios-auth.js'
import * as misc from '../../assets/misc.js'
import * as icn from '../../assets/task_icons.js'
// import {mapGetters} from 'vuex'
//import CompetitionResult from './competition_result'

export default {
    data() {
        return {
            competition_name: '',
            type_object: 'competition',
            content: null,
            showAttempts: -1,
            showCode: -1,
            course_id: -1,
            x_none: false
        }
    },
    components: {
//        CompetitionResult
        CodesInEditor
    },
    mounted() {
        this.initData()
    },

    methods : {
        initData() {
            this.$store.commit('setFeedback', null)   
            axios.get('/get-student-competition/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    /* eslint-disable no-console */
                    // console.log(res.data)
                    this.content = res.data
                    this.course_id = this.content.course.id
                    this.getCourseInfo()
                    if (this.content.task_list == null) {
                        this.$store.commit('setFeedback',this.content.message)
                        return
                    }
                    this.content.teacher_score = 0
                    for(let i = 0; i< this.content.task_list.length; i++)
                          this.content.teacher_score = this.content.teacher_score + this.content.task_list[i].teacher_score
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        getTaskIcon(index) {
            return icn.getTaskIcon(index)
        },
        showAtts(index) {
            this.showCode = -1
            if (this.showAttempts == index) this.showAttempts = -1
            else this.showAttempts = index
        },
        getCourseInfo() {
            axios.get('/get-vpl-course-info/' + this.course_id, this.$store.getters.getAxiosConfig )
                .then((res) => {
                    this.$store.commit('setEditorType',res.data.editorType)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                
        },
        saveData() {
            var count = 0
            for (let i = 0; i < this.content.task_list.length; i++) {
                var ts = this.content.task_list[i].teacher_score
                if (isNaN(ts)) ts = 0
                if ((Number.parseInt(ts) + this.content.task_list[i].score) > this.content.task_list[i].max_score) 
                ts = this.content.task_list[i].max_score - this.content.task_list[i].score
                const data = {
                    user_comp_id: this.content.competition.user_competition_id,
                    id : this.content.task_list[i].UCT_id,
                    teacher_score: ts,
                    comment : this.content.task_list[i].comment == null? '' : this.content.task_list[i].comment
                }
                axios.post('/write-teacher-comp-comment', data, this.$store.getters.getAxiosConfig )
                    .then((res) => {
                        if (res.data.message == 'OK') {
                            // set data to var
                            count = count + 1
                            if (count == this.content.task_list.length) this.initData()
                        } else {
                            this.$store.commit('setFeedback', res.data.message)    
                        }
                    })
                    .catch(error => {
                        this.$store.commit('setFeedback', error)
                    })
            }
        },
        processComment(comment) {
            return '- ' + misc.hardReplace(comment,'\n','<br>- ')
        }
    }
}

</script>
